import { MapPinOff } from 'lucide-react';
import type { ReactNode } from 'react';

import { ErrorState } from '@/components/error-state';

interface NotFoundStateProps {
  actions: ReactNode[];
}

export function NotFoundState({
  actions,
}: Readonly<NotFoundStateProps>): React.JSX.Element {
  return (
    <ErrorState
      tone="primary"
      icon={MapPinOff}
      code="404"
      headline="Page not found"
      description="The page you're looking for may have been moved, renamed, or no longer exists. Let's get you back to your patients."
      actions={actions}
      compact={false}
    />
  );
}
